import React, { useCallback, useEffect, useState } from 'react';
import { useSeller } from '../../hooks/useSeller';
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableContainer,
  ListItem,
  ListItemText
} from '@mui/material';
import LogoSpinner from '../LogoSpinner';
import { DynamicTable } from '../DynamicTable/DynamicTable';
import NumberInputIntroduction from '../shared/CustomNumberInput';
import { toDateTime } from '../../utils/payloadFormatter';
import { PageData } from '../../interface/interface';
import { OutlinedInput } from '@material-ui/core';
import { useDiscountStore } from '../../zustandStore/store.discount';

export interface VendorSelector {
  onSelect?: (vendor: Object) => void;
  selectedVendors?: { vendorId: string; vendorName: string }[];
  disabled?: boolean;
  onRemove?: (vendorId: string) => void;
  error?: string;
  currentValue?: any[];
}

const ITEM_HEIGHT = 100;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export const VendorSelector = (props: VendorSelector) => {
  const discountStore = useDiscountStore((state) => state);
  const { currentValue } = props;

  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [pageData, setPageData] = useState<PageData>(null);
  const { sellers, loading } = useSeller();

  // View the existing value
  console.log(currentValue);
  const [selectedVariant, setSelectedVariant] = useState<Map<string, any>>(
    new Map(
      currentValue?.length
        ? currentValue.map((item) => [item?.vendorId?.id, item?.vendorId])
        : [] || []
    )
  );

  console.log('Current Value:', currentValue);

  const handleInputChange = (value) => {
    if (!selectedVariant.has(value.id)) {
      selectedVariant.set(value.id, value);
      setSelectedVariant(new Map(selectedVariant));
      if (props.onSelect) {
        props.onSelect(value);
      }
    } else {
      selectedVariant.delete(value.id);
      setSelectedVariant(new Map(selectedVariant));
      if (props.onRemove) {
        props.onRemove(value.id);
      }
    }
  };

  useEffect(() => {}, [selectedVariant.size]);

  return (
    <>
      <Box>
        {loading ? (
          <Box
            sx={{
              height: '400px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <LogoSpinner />
          </Box>
        ) : (
          <FormControl
            sx={{
              mt: 4,
              width: '100%',
              px: 4,
              display: 'flex',
              flexDirection: 'column',
              gap: 2
            }}
          >
            <label htmlFor="vendor-multiple-checkbox">Select Vendors</label>
            <Select
              labelId="vendor-dropdown-label"
              id="vendor-multiple-checkbox"
              label="Select Vendors"
              multiple
              sx={{
                p: '1%'
              }}
              value={Array.from(selectedVariant.values()).map(
                (item) => item.name
              )}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
            >
              {sellers.map((item) => (
                <MenuItem
                  onClick={(e) => handleInputChange(item)}
                  key={item.name}
                  value={item}
                >
                  <Checkbox
                    checked={selectedVariant.has(item.id)}
                    onSelect={(event) => {
                      handleInputChange(item);
                    }}
                  />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>
    </>
  );
};
